interface Props {
  visible: boolean;
}

export function Flash({ visible }: Props) {
  return (
    <div
      aria-hidden
      style={{
        position: 'absolute',
        inset: 0,
        background: '#ffffff',
        opacity: visible ? 0.95 : 0,
        transition: 'opacity 220ms ease-out',
        pointerEvents: 'none',
        zIndex: 9,
      }}
    />
  );
}
